<content-panel>
    <panel-header heading={{this.pageTitle}}>
    </panel-header>

    <panel-body>
        <div class="desc-container">
            <b>{{ this.pagedesc}}</b>
        </div>
        <input type="file" class="file-upload" (change)="onFileSelected($event)" #fileInput>
        @if(incorrectFileType) {
            <div class="file-warning">
            {{ warningText }}
            </div>
        }   
    </panel-body>
    <section class="button-section">
        <button type="button" (click)="uploadFile()" class="upload-button" [disabled]="!validFields">
            {{ this.uploadBtnText }}
        </button>
    </section>
</content-panel>